import React, { useEffect, useState } from 'react';
import {
  Box,
  Typography,
  Collapse,
  RadioGroup,
  FormControlLabel,
  Radio,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  Button,
  Autocomplete,
  Chip,
  Avatar
} from '@mui/material';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import { api } from 'src/Api';

const TruckProfileForm = ({
  Profileopen,
  formData,
  errors,
  handleProfileOpen,
  handleChangeRadio,
  handleChangevalue,
  disabled,
  setFormData,
  convertedLength,
  convertedWeight
}) => {
  const [equipmentList, setEquipmentList] = useState([]);

  useEffect(() => {
    getEquipments();
  }, []);

  function getEquipments() {
    const myHeaders = new Headers();

    const token = localStorage.getItem('token');
    myHeaders.append('Authorization', `Bearer ${token}`);

    const requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };

    fetch(api.get_equipments, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        setEquipmentList(result.data);
      })
      .catch((error) => console.log('error', error));
  }
  const codeEquipment = equipmentList.filter((val) => val.id === formData?.equipmentType);

  return (
    <Box
      sx={{ boxShadow: '0px 4px 5px rgba(0, 0, 0, 0.1)' }}
      style={{
        borderRadius: 6,
        borderBottomLeftRadius: Profileopen ? 6 : 6,
        borderBottomRightRadius: Profileopen ? 6 : 6
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-start',
          alignItems: 'center',
          cursor: 'pointer',
          backgroundColor: '#EEEEEE',
          height: 40,
          padding: '0px 15px 0px 15px'
        }}
        style={{
          borderRadius: 6,
          borderBottomLeftRadius: Profileopen ? 0 : 6,
          borderBottomRightRadius: Profileopen ? 0 : 6
        }}
        onClick={handleProfileOpen}
      >
        <Typography
          variant="overline"
          sx={{ flex: 1, fontSize: 14, textTransform: 'capitalize', color: '#000' }}
        >
          Truck Profile
        </Typography>
        {Profileopen ? (
          <ExpandLess sx={{ color: '#000' }} />
        ) : (
          <ExpandMore sx={{ color: '#000' }} />
        )}
      </Box>

      <Box>
        <Collapse in={Profileopen}>
          <Box
            sx={{ flexWrap: 'nowrap', padding: '0px 15px 0px 15px' }}
            style={{
              borderBottomLeftRadius: Profileopen ? 6 : 0,
              borderBottomRightRadius: Profileopen ? 6 : 0
            }}
          >
            <Typography
              sx={{
                marginTop: 2,
                borderBottom: '2px solid #EEEEEE',
                paddingBottom: 0.5,
                marginBottom: 1,
                color: '#000000',
                fontSize: 13,
                fontWeight: 'bold',
                textTransform: 'capitalize'
              }}
            >
              Truck Details
            </Typography>
            <RadioGroup
              row
              value={formData?.truckType}
              onChange={handleChangeRadio}
              name="truckType"
            >
              <FormControlLabel
                disabled={disabled}
                value="Full"
                control={<Radio size="small" style={{ color: '#000' }} />}
                label={<Typography style={{ fontSize: '13px', color: '#000' }}>Full</Typography>}
              />
              <FormControlLabel
                disabled={disabled}
                value="Partial"
                control={<Radio size="small" style={{ color: '#000' }} />}
                label={<Typography style={{ fontSize: '13px', color: '#000' }}>Partial</Typography>}
              />
            </RadioGroup>
            {errors.truckType && (
              <p style={{ fontSize: 12, color: '#FF4842', marginBottom: 5, marginTop: -5 }}>
                {errors.truckType}
              </p>
            )}

            <Grid container spacing={2} mb={2} mt={-1}>
              {/* Equipment Type Dropdown */}
              <Grid item xs={4} md={6}>
                <TextField
                  disabled={disabled}
                  select
                  label="Equipment Type *"
                  name="equipmentType"
                  value={formData?.equipmentType || ''}
                  onChange={handleChangevalue}
                  fullWidth
                  error={Boolean(errors.equipmentType)}
                  helperText={errors.equipmentType}
                  InputLabelProps={{
                    shrink: true, // Force the label to shrink when a value is selected
                    style: {
                      fontSize: '11px',
                      lineHeight: '1.2',
                      transform: 'translate(14px, -6px) scale(1)' // Adjust position of label
                    }
                  }}
                  SelectProps={{
                    MenuProps: {
                      PaperProps: {
                        style: {
                          paddingTop: 0 // Ensure the dropdown aligns properly
                        }
                      }
                    }
                  }}
                  InputProps={{
                    style: {
                      fontSize: 14,
                      height: '50px', // Set the height of the input field
                      padding: '0px 0px' // Add padding to input field
                    }
                  }}
                >
                  {equipmentList.map((option) => (
                    <MenuItem key={option.id} value={option.id}>
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          width: '100%'
                        }}
                      >
                        <span
                          style={{
                            flex: 1,
                            textAlign: 'start',
                            display: 'flex',
                            fontWeight: 'normal',
                            marginRight: 10,
                            fontSize: 14
                          }}
                        >
                          {option.name}
                        </span>
                        <span
                          style={{
                            flex: 1,
                            width: '100%',
                            textAlign: 'right',
                            fontWeight: 'bold',
                            fontSize: 14,
                            color: '#000'
                          }}
                        >
                          {option.code}
                        </span>
                      </div>
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>

              {/* Length Input */}
              <Grid item xs={4} md={3}>
                <TextField
                  disabled={disabled}
                  type="number"
                  fullWidth
                  label={`Length (${formData?.length_unit}.) `}
                  name="length"
                  value={formData?.length}
                  onChange={handleChangevalue}
                  error={Boolean(errors.length)}
                  helperText={errors.length}
                  required
                  className="custom-textfield"
                  onKeyDown={(e) => {
                    if (e.key === 'e' || e.key === 'E' || e.key === '+' || e.key === '-') {
                      e.preventDefault(); // Prevent "e", "E", "+", and "-" from being typed
                    }
                  }}
                  InputProps={{
                    endAdornment: (
                      <select
                        value={formData?.length_unit} // Default to "ft" if not set
                        name="length_unit"
                        onChange={handleChangevalue}
                        style={{
                          border: 'none',
                          outline: 'none',
                          background: 'transparent',
                          cursor: 'pointer',
                          fontSize: 14
                        }}
                      >
                        <option value="ft">ft</option>
                        <option value="m">m</option>
                      </select>
                    )
                  }}
                />
                <p
                  style={{
                    fontSize: 11,
                    fontWeight: 'bold',
                    marginLeft: 15,
                    marginTop: 2,
                    color: 'gray',
                    letterSpacing: 0.5
                  }}
                >
                  {convertedLength ? `${convertedLength}` : ''}
                </p>
              </Grid>

              {/* Weight Input */}
              <Grid item xs={4} md={3}>
                <TextField
                  disabled={disabled}
                  type="number"
                  fullWidth
                  label={`Weight (${formData?.weight_unit}.) `}
                  name="weight"
                  required
                  value={formData?.weight}
                  onChange={handleChangevalue}
                  error={Boolean(errors.weight)}
                  helperText={errors.weight}
                  className="custom-textfield"
                  onKeyDown={(e) => {
                    if (e.key === 'e' || e.key === 'E' || e.key === '+' || e.key === '-') {
                      e.preventDefault(); // Prevent "e", "E", "+", and "-" from being typed
                    }
                  }}
                  InputProps={{
                    endAdornment: (
                      <select
                        value={formData?.weight_unit} // Default to "ft" if not set
                        name="weight_unit"
                        onChange={handleChangevalue}
                        style={{
                          border: 'none',
                          outline: 'none',
                          background: 'transparent',
                          cursor: 'pointer'
                          // fontSize: 12
                        }}
                      >
                        <option value="kg">kg</option>
                        <option value="lbs">lbs</option>
                      </select>
                    )
                  }}
                />
                <p
                  style={{
                    fontSize: 11,
                    fontWeight: 'bold',
                    marginLeft: 15,
                    marginTop: 2,
                    color: 'gray',
                    letterSpacing: 0.5
                  }}
                >
                  {convertedWeight ? `${convertedWeight}` : ''}
                </p>
              </Grid>
            </Grid>
          </Box>
        </Collapse>
      </Box>
    </Box>
  );
};

export default TruckProfileForm;
